export default __webpack_public_path__ + "static/media/WellBHPPredictor1.f813fd75.png";